import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=99c5fe7a&scoped=true"
import script from "./DocumentEditor.vue?vue&type=script&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&lang=js"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=99c5fe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c5fe7a",
  null
  
)

export default component.exports